<template>
  <div class="about">
    <ui-title>{{ t('about.title') }}</ui-title>
    <div class="container">
      <div class="about__inner" v-html="content"></div>
    </div>
  </div>
</template>

<script setup>
import UiTitle from "@/components/ui/ui-title.vue";
import {useI18n} from "vue-i18n";
import {onMounted, ref, watch} from "vue";
import {Docs} from "@/core/api/docs.js";

const {t, locale} = useI18n()

const content = ref(null)

const getDocs = async () => {
  const res = await Docs.getDocs("about-us")

  if (res.data.posts.edges.length) {
    content.value = res.data.posts.edges[0].node.content
  }
}

watch(locale, async () => {
  await getDocs()
})

onMounted( async () => {
  await getDocs()
})
</script>

<style lang="scss" scoped>
.about {
  &__inner {
    margin-top: 50px;
  }
}

:deep(ul) {
  padding-left: 30px;
}
:deep(a) {
  color: #ff6162;
  transition: 0.2s;

  @include hover {
    color: #fc4546;
  }
}
</style>